// App name: AdBlue Form
// Description:

const AdBlueFormApp = (function ($) {

  // variables
  let _container      = $('.form__adBlue--container');
  let _pagination     = _container.find('.forminator-pagination');
  let _w              = $(window).width();


  // init
  function init() {

    initAdBlueTabDesktop();


    if (_w < 768) {
      initAdBlueTabMobile();
      initOverideTabs();
      initAnchor(100);
    } else {
      initAnchor(300);
    }
  }

  function initAdBlueTabMobile() {
    let _tabs       = _container.find('.form__adBlue--tab');

    // Open First Tab
    setTimeout(function() {
      $('.form__adBlue--step1').toggleClass('is-active')
        .closest('.forminator-pagination--content').toggleClass('is-active');
    }, 500);

    // Tabs
    _tabs.on('click', function() {
      let _self = $(this);

      if (!_self.hasClass('is-active')) {
        let _step    = _self.closest('.forminator-pagination').data('step');
        let _nextNav = _container.find('.forminator-step[data-nav="' + _step + '"]').click();

        if (_nextNav.attr('aria-selected') == 'true') {
          setTimeout(function() {
            // Close tab was active
            $('.form__adBlue--tab').removeClass('is-active')
            .closest('.forminator-pagination--content').removeClass('is-active');

            _self.toggleClass('is-active')
                  .closest('.forminator-pagination--content').toggleClass('is-active');

            initOverideTabs();
          }, 300);
        } else {
          setTimeout(function() {
            initOverideTabs();
          }, 300);
        }
      }
    });

    // Buttons
    setTimeout(function() {
      let _buttonMore = _container.find('.form_more');
      let _buttonSubmit = _container.find('.form_submit');

      _buttonMore.on('click', function(e) {
        e.preventDefault();

        _container.find('.forminator-pagination-footer .forminator-button-next').click();

        setTimeout(function() {
          let _step = _container.find('.forminator-step[aria-selected="true"]').data('nav');
          let _tab = _container.find('.forminator-pagination[data-step="'+_step+'"]');

          // Close tab was active
          $('.form__adBlue--tab').removeClass('is-active')
          .closest('.forminator-pagination--content').removeClass('is-active');

          _tab.find('.form__adBlue--tab').toggleClass('is-active');
          _tab.find('.forminator-pagination--content').toggleClass('is-active');

          initOverideTabs();
        }, 500);
      });

      _buttonSubmit.on('click', function() {
        _container.find('.forminator-pagination-submit').prop('disabled', false).click();

        setTimeout(function() {
          initOverideTabs();
        }, 1000);

      });

    }, 500);

  }

  function initAdBlueTabDesktop() {
    setTimeout(function() {
      let _trigger   = _container.find('.forminator-button-next');
      let _finalTabs  = _container.find('.forminator-pagination-steps button.forminator-step[data-nav="3"]')

      _trigger.on('click', function() {
        initGetDataInput();
      });

      _finalTabs.on('click', function() {
        initGetDataInput();
      });
    }, 1000);
  }

  function initOverideTabs() {
    // Show all tab because Forminator form only show one tab by default
    setTimeout(function() {
      _pagination.removeAttr('hidden');
      _pagination.find('.forminator-pagination--content').show();
    }, 100);


    // setTimeout(function() {
    //   _pagination.find('.forminator-button-next').on('click', function() {

    //     setTimeout(function() {
    //       _pagination.removeAttr('hidden');
    //       _pagination.find('.forminator-pagination--content').show();
    //     }, 500);
    //   });

    // }, 1000);
  }

  function initGetDataInput() {
    let _finalStep = _container.find('.forminator-step[data-nav="3"]');

    if ( _finalStep.attr('aria-selected') == 'true' ) {
      let _name    = _container.find('.form__input--name input').val();
      let _vorname = _container.find('.form__input--vorname input').val();
      let _address = _container.find('.form__input--address input').val();
      let _ort     = _container.find('.form__input--ort input').val();
      let _phone   = _container.find('.form__input--phone input').val();
      let _email   = _container.find('.form__input--email input').val();

      setTimeout(function() {
        $('.form__adBlue-infos .infos__container').append(
          `<div>${_name} ${_vorname}</div>
           <div>${_address}</div>
           <div>${_ort}</div>
           <div>${_phone}</div>
           <div>${_email}</div>`
        );

        $('.form__adBlue-orderOverview .order__container').append(initGetOrder());
      }, 1000);
    }
  }

  function initGetOrder() {
    let _order = '';

    $('.form__adBlue--image').each(function() {
      let _self = $(this);

      if (_self.find('input').val().replace(/\s/g, "").length > 0) {
        _order = _order + `<div>${_self.find('input').val()}x ${_self.find('label').text()}</div>`;
      } else {
        _order = _order;
      }
    });

    return _order;
  }

  function initAnchor(value) {
    let _btn = $('.for-adblue-page');

    _btn.on('click', function() {
      $('html, body').animate({
        scrollTop: $('#adblue-section').offset().top - value
      },'slow');
    });
  }

  return {
      init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  AdBlueFormApp.init();
});
